import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const ShortFormSavedTemplate = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1447_8918)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#D0F4FF"
          />
          <path
            d="M186.052 65.9531V141.468C186.052 143.176 185.374 144.814 184.166 146.021C182.959 147.229 181.321 147.907 179.613 147.907H68.4393C66.7315 147.907 65.0936 147.229 63.886 146.021C62.6784 144.814 62 143.176 62 141.468V65.9531H186.052Z"
            fill="white"
          />
          <path
            d="M185.909 65.9558H61.8564V56.2968C61.8564 54.5889 62.5349 52.9511 63.7425 51.7435C64.9501 50.5359 66.588 49.8574 68.2958 49.8574H179.469C181.177 49.8574 182.815 50.5359 184.023 51.7435C185.23 52.9511 185.909 54.5889 185.909 56.2968V65.9558Z"
            fill="white"
          />
          <path
            d="M185.909 135V56.2968C185.909 54.5889 185.23 52.9511 184.023 51.7435C182.815 50.5359 181.177 49.8574 179.469 49.8574H163.5H68.2958C66.588 49.8574 64.9501 50.5359 63.7425 51.7435C62.5349 52.9511 61.8564 54.5889 61.8564 56.2968V141.47C61.8564 143.178 62.5349 144.816 63.7425 146.024C64.9501 147.231 66.588 147.91 68.2958 147.91H179.469C181.177 147.91 182.815 147.231 184.023 146.024C185.23 144.816 185.909 143.178 185.909 141.47V128"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M62.8564 65.9531H185.5"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M74.1252 58.7094C73.9118 58.7094 73.707 58.6246 73.5561 58.4737C73.4051 58.3227 73.3203 58.118 73.3203 57.9045C73.3203 57.691 73.4051 57.4863 73.5561 57.3354C73.707 57.1844 73.9118 57.0996 74.1252 57.0996"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M74.125 58.7094C74.3385 58.7094 74.5432 58.6246 74.6942 58.4737C74.8451 58.3227 74.9299 58.118 74.9299 57.9045C74.9299 57.691 74.8451 57.4863 74.6942 57.3354C74.5432 57.1844 74.3385 57.0996 74.125 57.0996"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M157.147 76.1455H89.6323C89.2053 76.1455 88.7959 76.3151 88.494 76.617C88.1921 76.9189 88.0225 77.3284 88.0225 77.7553V95.1947C88.0225 95.6216 88.1921 96.0311 88.494 96.333C88.7959 96.6349 89.2053 96.8045 89.6323 96.8045H157.147C157.574 96.8045 157.983 96.6349 158.285 96.333C158.587 96.0311 158.757 95.6216 158.757 95.1947V77.7553C158.757 77.3284 158.587 76.9189 158.285 76.617C157.983 76.3151 157.574 76.1455 157.147 76.1455Z"
            fill="#FFEF5E"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M97.3223 84.8554H98.3682L99.6426 88.3578L100.921 84.8554H101.963L100.064 89.975H99.2251L97.3223 84.8554ZM96.6982 84.8554H97.7661L97.9683 88.8676V89.975H96.6982V84.8554ZM101.523 84.8554H102.6V89.975H101.326V88.8676L101.523 84.8554ZM105.197 87.6196L106.524 84.8554H107.896L106.019 88.3051H105.333L105.197 87.6196ZM104.411 84.8554L105.747 87.6459L105.593 88.3051H104.916L103.035 84.8554H104.411ZM106.085 87.5668V89.975H104.815V87.5668H106.085ZM113.187 84.8554V89.975H111.912V84.8554H113.187ZM114.852 84.8554V85.8486H110.282V84.8554H114.852ZM119.207 88.9863V89.975H116.263V88.9863H119.207ZM116.711 84.8554V89.975H115.445V84.8554H116.711ZM118.829 86.8329V87.8217H116.263V86.8329H118.829ZM119.211 84.8554V85.8486H116.263V84.8554H119.211ZM120.402 84.8554H121.448L122.723 88.3578L124.001 84.8554H125.043L123.145 89.975H122.305L120.402 84.8554ZM119.778 84.8554H120.846L121.048 88.8676V89.975H119.778V84.8554ZM124.604 84.8554H125.68V89.975H124.406V88.8676L124.604 84.8554ZM128.739 88.2656H127.359V87.2768H128.739C128.932 87.2768 129.092 87.249 129.218 87.1933C129.344 87.1347 129.436 87.0571 129.495 86.9604C129.556 86.8608 129.587 86.748 129.587 86.622C129.587 86.4843 129.556 86.3569 129.495 86.2397C129.436 86.1225 129.344 86.0287 129.218 85.9584C129.092 85.8852 128.932 85.8486 128.739 85.8486H127.829V89.975H126.563V84.8554H128.739C129.178 84.8554 129.555 84.9316 129.868 85.0839C130.185 85.2363 130.426 85.4443 130.593 85.7079C130.763 85.9716 130.848 86.2734 130.848 86.6132C130.848 86.8593 130.8 87.0849 130.703 87.29C130.609 87.4921 130.47 87.6664 130.286 87.8129C130.104 87.9594 129.883 88.0722 129.622 88.1513C129.364 88.2275 129.07 88.2656 128.739 88.2656ZM135.194 88.9863V89.975H132.408V88.9863H135.194ZM132.856 84.8554V89.975H131.591V84.8554H132.856ZM137.976 86.187L136.614 89.975H135.335L137.356 84.8554H138.227L137.976 86.187ZM139.321 89.975L137.932 86.187L137.677 84.8554H138.561L140.595 89.975H139.321ZM139.294 88.0722V88.9731H136.464V88.0722H139.294ZM143.368 84.8554V89.975H142.094V84.8554H143.368ZM145.034 84.8554V85.8486H140.463V84.8554H145.034ZM149.389 88.9863V89.975H146.444V88.9863H149.389ZM146.893 84.8554V89.975H145.627V84.8554H146.893ZM149.011 86.8329V87.8217H146.444V86.8329H149.011ZM149.393 84.8554V85.8486H146.444V84.8554H149.393Z"
            fill="#1E1E1E"
          />
          <path
            d="M89.0225 102.95H154.022"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M89.0225 108.95H146.022"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M89.0225 114.95H127.022"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M100.818 123.95H89.1857C88.8772 123.95 88.5813 124.073 88.3632 124.291C88.145 124.509 88.0225 124.805 88.0225 125.113V134.419C88.0225 134.728 88.145 135.024 88.3632 135.242C88.5813 135.46 88.8772 135.583 89.1857 135.583H100.818C101.127 135.583 101.422 135.46 101.641 135.242C101.859 135.024 101.981 134.728 101.981 134.419V125.113C101.981 124.805 101.859 124.509 101.641 124.291C101.422 124.073 101.127 123.95 100.818 123.95Z"
            fill="#D0F4FF"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M105.981 126.266H153.981"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M105.981 133.266H143.981"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M83.7839 58.7094C83.5704 58.7094 83.3657 58.6246 83.2148 58.4737C83.0638 58.3227 82.979 58.118 82.979 57.9045C82.979 57.691 83.0638 57.4863 83.2148 57.3354C83.3657 57.1844 83.5704 57.0996 83.7839 57.0996"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M83.7837 58.7094C83.9972 58.7094 84.2019 58.6246 84.3529 58.4737C84.5038 58.3227 84.5886 58.118 84.5886 57.9045C84.5886 57.691 84.5038 57.4863 84.3529 57.3354C84.2019 57.1844 83.9972 57.0996 83.7837 57.0996"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M93.4431 58.7114C93.2296 58.7114 93.0249 58.6266 92.8739 58.4756C92.723 58.3247 92.6382 58.12 92.6382 57.9065C92.6382 57.693 92.723 57.4883 92.8739 57.3373C93.0249 57.1864 93.2296 57.1016 93.4431 57.1016"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M93.4429 58.7114C93.6563 58.7114 93.8611 58.6266 94.012 58.4756C94.163 58.3247 94.2478 58.12 94.2478 57.9065C94.2478 57.693 94.163 57.4883 94.012 57.3373C93.8611 57.1864 93.6563 57.1016 93.4429 57.1016"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <rect
            x="158.053"
            y="30"
            width="46"
            height="46"
            rx="23"
            fill="#F8FBF6"
          />
          <rect
            x="158.053"
            y="30"
            width="46"
            height="46"
            rx="23"
            stroke="#1E1E1E"
            strokeWidth="2"
          />
          <path
            d="M188.705 66.2703L181.053 60.9136L173.4 66.2703C173.264 66.3655 173.105 66.4216 172.939 66.4324C172.773 66.4433 172.608 66.4085 172.461 66.3318C172.313 66.2552 172.19 66.1396 172.104 65.9977C172.017 65.8557 171.972 65.6929 171.972 65.5268V41.8434C171.972 41.3617 172.163 40.8997 172.504 40.5591C172.844 40.2185 173.306 40.0272 173.788 40.0272H188.318C188.799 40.0272 189.261 40.2185 189.602 40.5591C189.942 40.8997 190.134 41.3617 190.134 41.8434V65.5268C190.134 65.6929 190.088 65.8557 190.002 65.9977C189.916 66.1396 189.792 66.2552 189.645 66.3318C189.498 66.4085 189.332 66.4433 189.166 66.4324C189.001 66.4216 188.841 66.3655 188.705 66.2703Z"
            fill="#FFEF5E"
            stroke="#1E1E1E"
            strokeWidth="1.2973"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g clipPath="url(#clip1_1447_8918)">
            <path
              d="M199.388 94.168L201.213 88.1912L207.188 90.0231"
              stroke="#1E1E1E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M201.584 88.0343C208.098 95.2861 207.798 103.81 197.496 107.387"
              stroke="#1E1E1E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M36.7875 20.4061L41.7682 26.5088L47.7417 24.9598C48.0404 24.8701 48.3604 24.8719 48.6581 24.9649C48.9558 25.058 49.2165 25.2378 49.4047 25.4798C49.5929 25.7218 49.6994 26.0142 49.7096 26.3169C49.7198 26.6196 49.6332 26.918 49.4617 27.1712L45.5135 32.9919L50.1592 38.6492C50.3663 38.9093 50.4841 39.2258 50.4959 39.554C50.5077 39.8823 50.4129 40.2058 50.2249 40.4791C50.0369 40.7524 49.7651 40.9616 49.4478 41.0775C49.1305 41.1933 48.7836 41.2098 48.456 41.1248L40.4756 39.1325L34.5844 44.7321C34.3447 44.9643 34.0357 45.1178 33.7011 45.171C33.3665 45.2243 33.023 45.1745 32.719 45.0288C32.415 44.8831 32.1657 44.6488 32.0063 44.3588C31.8469 44.0689 31.7854 43.7378 31.8304 43.4123L32.9221 36.2569L26.4955 33.1264C26.2148 32.992 25.984 32.7766 25.8349 32.5099C25.6858 32.2432 25.6257 31.9384 25.6628 31.6373C25.7 31.3362 25.8327 31.0538 26.0425 30.8288C26.2523 30.6039 26.529 30.4475 26.8345 30.3812L32.82 28.8291L33.9843 21.1329C34.0528 20.8516 34.1988 20.5936 34.4066 20.3861C34.6144 20.1787 34.8764 20.0298 35.1647 19.955C35.453 19.8802 35.7568 19.8825 36.044 19.9616C36.3311 20.0406 36.5908 20.1935 36.7955 20.404L36.7875 20.4061Z"
            fill="#FFEF5E"
          />
          <path
            d="M41.7673 26.5064L36.7865 20.4037C36.5819 20.1932 36.3222 20.0404 36.035 19.9613C35.7479 19.8823 35.444 19.88 35.1557 19.9547C34.8674 20.0295 34.6055 20.1785 34.3976 20.3859C34.1898 20.5933 34.0439 20.8514 33.9754 21.1327L32.811 28.8288L26.8256 30.3809C26.5217 30.4492 26.247 30.6065 26.0388 30.8315C25.8306 31.0564 25.699 31.338 25.6619 31.638C25.6249 31.938 25.6842 32.2418 25.8317 32.5081C25.9793 32.7743 26.2079 32.9902 26.4866 33.1262L32.9132 36.2567L31.8273 43.4022C31.78 43.7815 31.8784 44.1644 32.1038 44.478L43.0043 26.1857L41.7673 26.5064Z"
            fill="#FFF9BF"
          />
          <path
            d="M36.7875 20.4061L41.7682 26.5088L47.7417 24.9598C48.0404 24.8701 48.3604 24.8719 48.6581 24.9649C48.9558 25.058 49.2165 25.2378 49.4047 25.4798C49.5929 25.7218 49.6994 26.0142 49.7096 26.3169C49.7198 26.6196 49.6332 26.918 49.4617 27.1712L45.5135 32.9919L50.1592 38.6492C50.3663 38.9093 50.4841 39.2258 50.4959 39.554C50.5077 39.8823 50.4129 40.2058 50.2249 40.4791C50.0369 40.7524 49.7651 40.9616 49.4478 41.0775C49.1305 41.1933 48.7836 41.2098 48.456 41.1248L40.4756 39.1325L34.5844 44.7321C34.3447 44.9643 34.0357 45.1178 33.7011 45.171C33.3665 45.2243 33.023 45.1745 32.719 45.0288C32.415 44.8831 32.1657 44.6488 32.0063 44.3588C31.8469 44.0689 31.7854 43.7378 31.8304 43.4123L32.9221 36.2569L26.4955 33.1264C26.2148 32.992 25.984 32.7766 25.8349 32.5099C25.6858 32.2432 25.6257 31.9384 25.6628 31.6373C25.7 31.3362 25.8327 31.0538 26.0425 30.8288C26.2523 30.6039 26.529 30.4475 26.8345 30.3812L32.82 28.8291L33.9843 21.1329C34.0528 20.8516 34.1988 20.5936 34.4066 20.3861C34.6144 20.1787 34.8764 20.0298 35.1647 19.955C35.453 19.8802 35.7568 19.8825 36.044 19.9616C36.3311 20.0406 36.5908 20.1935 36.7955 20.404L36.7875 20.4061Z"
            stroke="#1E1E1E"
            strokeWidth="1.85651"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1447_8918">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip1_1447_8918">
            <rect
              width="25.2527"
              height="23.5332"
              fill="white"
              transform="matrix(0.953168 -0.30244 -0.302449 -0.953166 192.337 112.033)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
